export default __webpack_public_path__ + "static/join-4e513f7a1cd3968ea589fb47d7b23b74.png";